import { render, staticRenderFns } from "./Install.List.vue?vue&type=template&id=2963a9be&"
import script from "./Install.List.vue?vue&type=script&lang=js&"
export * from "./Install.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports